import { FC, memo } from 'react';

import GenericLayout from '../../components/generic-layout/GenericLayout';
import PageImage from '../../components/page-image/PageImage';
import { PageImageId } from '../../components/page-image/type';
import Methode from './Methode';
import Pyramide from './Pyramide';
import Shop from './Shop';

const Ranking: FC = () => (
  <GenericLayout title='Graduierung-System'>
    <PageImage id={PageImageId.Ranking} />

    <Methode />
    <Pyramide />
    <Shop />
  </GenericLayout>
);

export default memo(Ranking);
